import * as THREE from 'three';
import { IGltfDoor, IGltfWindow } from '../@types/Gltf';

/**
 * Function to calculate the position of a window or door object.
 * Is needed because the old floorplanner only saved their locations in relation to their respective wall.
 *
 * @param {THREE.Vector3} wallStartPoint the starting point of the respective wall.
 * @param {THREE.Vector3} wallEndPoint the end point of the respective wall.
 * @param {IGltfDoor | IGltfWindow} object the door or window object where we need to calculate the position.
 * @returns {THREE.Vector3} the position of the object.
 */
export const calculateObjectPositionOnWall = (
  wallStartPoint: THREE.Vector3,
  wallEndPoint: THREE.Vector3,
  object: IGltfDoor | IGltfWindow,
): THREE.Vector3 => {
  const dX = wallEndPoint.x - wallStartPoint.x;
  const dY = wallEndPoint.y - wallStartPoint.y;
  const vectorLength = Math.sqrt(dX * dX + dY * dY);
  const normVectorX = dX / vectorLength;
  const normVectorY = dY / vectorLength;
  const objPosX = wallStartPoint.x + object.distanceFromWall * normVectorX;
  const objPosY = wallStartPoint.y + object.distanceFromWall * normVectorY;
  return new THREE.Vector3(objPosX, objPosY, 0);
};
